<template>
  <v-row>
    <v-col cols="auto">
      <v-dialog
        transition="dialog-top-transition"
        max-width="800"
        v-model="dialogSummary"
        persistent
      >
        <v-card>
          <v-toolbar color="#59805c" dark>Resumen de envío(s)</v-toolbar>
          <v-card-text>
            <v-col
              v-for="study in summaryList"
              :key="study.idStudy"
              cols="12"
              md="12"
              sm="12"
            >
              <v-icon
                slot="append"
                :color="study.sendStatus == 1 ? 'success' : 'error'"
              >
                {{ study.sendStatus == 1 ? " mdi-check" : "mdi-close" }}
              </v-icon>
              <span>
                <strong> Id estudio: </strong> {{ study.idStudy }} <br/>
                <strong> Paciente: </strong> {{ study.fullNamePatient }} <br/>
                <strong> Estudio: </strong> {{ study.fullNameStudyProfile}} <br/>
                <strong> Resultado: </strong> {{ study.messageAnswer }}
              </span>
            </v-col>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="closeDialogSummary()" color="error"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    dialogSummary: Boolean,
    summaryList: Array,
  },
  data() {
    return {};
  },
  methods: {
    closeDialogSummary() {
      let dialogSummary = false;
      this.$emit("closeDialogSummary", dialogSummary);
    },
  },
};
</script>

<style></style>
